import { render } from "./StudentSubmissionUtilDataTable.vue?vue&type=template&id=37f6de41&scoped=true"
import script from "./StudentSubmissionUtilDataTable.vue?vue&type=script&lang=js"
export * from "./StudentSubmissionUtilDataTable.vue?vue&type=script&lang=js"

import "./StudentSubmissionUtilDataTable.vue?vue&type=style&index=0&id=37f6de41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f6de41"]])

export default __exports__